import { Smartphone, Play, Gavel, FileCheck2, ScrollText } from "lucide-react";
import { SearchSimulator } from "@/components/landing/SearchSimulator";

const StoreButton = ({ icon: Icon, small, label, testid }) => (
  <button type="button" disabled title="Presto disponibile" data-testid={testid}
    className="inline-flex cursor-not-allowed items-center gap-3 rounded-xl bg-[#0f172a] px-5 py-3 text-left text-white opacity-90">
    <Icon className="h-5 w-5" />
    <span className="leading-tight">
      <span className="block text-[10px] uppercase tracking-wider text-slate-400">{small}</span>
      <span className="block text-sm font-semibold">{label}</span>
    </span>
  </button>
);

const trust = [
  { icon: Gavel, text: "Solo provvedimenti del Tribunale" },
  { icon: FileCheck2, text: "Ogni PDF verificato prima della pubblicazione" },
  { icon: ScrollText, text: "Registro di ogni ricerca effettuata" },
];

export const Hero = () => (
  <section className="relative overflow-hidden">
    <div className="grid-bg absolute inset-0 -z-10" />
    <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 pb-20 pt-12 sm:px-6 md:pb-28 md:pt-20 lg:grid-cols-[1.05fr_1fr] lg:px-8">
      <div className="fade-up">
        <span className="eyebrow-label"><span className="pulse-dot h-2 w-2 rounded-full bg-[#16a34a]" />Trasparenza e Tutela nelle Locazioni</span>
        <h1 data-testid="hero-h1-title" className="mt-6 text-4xl font-extrabold leading-[1.08] tracking-tight text-[#0f172a] sm:text-5xl lg:text-6xl">
          Scegli l'Inquilino Giusto con <span className="text-[#2563eb]">Dati Certificati</span>
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-[#64748b] sm:text-lg">
          La prima piattaforma in Italia per monitorare i pagamenti degli affitti e verificare la presenza di sfratti esecutivi in modo 100% legale e conforme al GDPR.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <StoreButton icon={Smartphone} small="Presto su" label="App Store (iOS)" testid="app-store-button-ios" />
          <StoreButton icon={Play} small="Presto su" label="Google Play (Android)" testid="google-play-button-android" />
        </div>
        <ul className="mt-12 grid gap-4 border-t border-slate-200 pt-8 sm:grid-cols-3">
          {trust.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-start gap-3 text-sm font-medium text-[#0f172a]">
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#1e3a8a]" />
              {text}
            </li>
          ))}
        </ul>
      </div>
      <div className="relative fade-up delay-2">
        <div className="absolute -right-6 top-0 hidden h-[480px] w-[72%] overflow-hidden rounded-3xl lg:block">
          <img src="/images/hero-apartment.jpg" alt="Palazzo residenziale" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-[#172554]/25" />
        </div>
        <div className="relative z-10 lg:mr-auto lg:mt-16 lg:max-w-md">
          <SearchSimulator />
        </div>
      </div>
    </div>
  </section>
);
